<template>
  <main class="container">
    <h1>Welcome to We are family Corp.</h1>
    <p>
      We specialize in cutting edge face recognition to help as many people as
      possible find their long-lost relatives and forgotton ancestors.
    </p>
    <p>
      Hit the start button and we gurantee: You’ll be celebrating unexpected
      family reunions within minutes.
    </p>
    <p>
      Disclaimer: No files will be uploaded during the game. Every image used
      stays on YOUR machine only!
    </p>
    <button @click="startGame()">Start</button>
  </main>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  methods: {
    startGame() {
      this.$router.push({ name: "PlayerLobby" });
    },
  },
};
</script>

<style lang="stylus"></style>
